import React from 'react';
import { ArrowDown } from '@fabric-ui/icons';
import { Box, BoxProps, Skeleton, SxProps, Theme, useTheme } from '@mui/material';
import { sanitize } from '@utils/utils';

interface FoundCountResultsProps {
  label: string;
  count?: number;
  height?: number;
  loading?: boolean;
  style?: SxProps<Theme>;
}

export const FoundCountResults = ({ label, count = 0, height = 21, loading, style }: FoundCountResultsProps): React.JSX.Element =>
  loading ? (
    <Skeleton height={height} width={160} />
  ) : (
    <Box sx={{ ...style }}>
      <strong>{count.toLocaleString()}</strong> {label} found
    </Box>
  );

interface CollapseArrowProps {
  isExpanded?: boolean;
}

export function CollapseArrow({ isExpanded = false }: CollapseArrowProps): React.JSX.Element {
  const theme = useTheme();
  return (
    <ArrowDown
      style={{
        transform: `rotate(${isExpanded ? 0 : -90}deg)`,
        transition: theme.transitions.create(['transform'], {
          duration: theme.transitions.duration.shorter,
        }),
      }}
    />
  );
}

interface SanitizeHTMLProps extends BoxProps {
  html: string;
}

const styleHTML = {
  'pre, code': {
    backgroundColor: 'var(--color-surface-base-tertiary)',
    color: 'inherit',
  },
  pre: {
    whiteSpace: 'pre-wrap',
    my: '5px',
    padding: '5px 10px',
  },
  code: {
    fontSize: 13,
    padding: '2px 4px',
  },
  a: {
    color: ({ palette }) => palette.primary.main,
    '&:hover': {
      textDecoration: 'underline',
    },
  },
};

export function SanitizeHTML({ html, ...props }: SanitizeHTMLProps): React.JSX.Element {
  return <Box sx={styleHTML} dangerouslySetInnerHTML={{ __html: sanitize(html) }} {...props} />;
}
